import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, IconEmailSent, InlineTextButton, IconClose } from '../../components';
import { supabase } from '../../supabase/client';
import css from './AuthenticationPage.module.css';

const EmailVerificationInfo = props => {
  const { name, email, rawEmail, onDismiss } = props;
  const [resendStatus, setResendStatus] = useState(null);

  const handleResend = async () => {
    setResendStatus('sending');
    const { error } = await supabase.auth.resend({ type: 'signup', email: rawEmail || '' });
    setResendStatus(error ? 'error' : 'sent');
  };

  return (
    <div className={css.content}>
      
      <IconEmailSent className={css.modalIcon} />
      <Heading as="h1" rootClassName={css.modalTitle}>
  {name}, check your email to verify your account
</Heading>
<p className={css.modalMessage}>
  Thanks for signing up! Please verify your email address by clicking the link we sent to {email}.
</p>
      <p className={css.modalHelperText}>
  <span>Wrong email? </span>
  <InlineTextButton rootClassName={css.modalHelperLink} onClick={() => window.location.href = '/signup'}>
    Sign up again
  </InlineTextButton>
</p>
      <div className={css.bottomWrapper}>
        <p className={css.modalHelperText}>
          {resendStatus === 'sending' ? (
            <FormattedMessage id="AuthenticationPage.sendingEmail" />
          ) : resendStatus === 'sent' ? (
            <span>Email sent!</span>
          ) : resendStatus === 'error' ? (
            <span>Failed to resend. Try again.</span>
          ) : (
            <InlineTextButton rootClassName={css.modalHelperLink} onClick={handleResend}>
              <FormattedMessage id="AuthenticationPage.resendEmailLinkText" />
            </InlineTextButton>
          )}
        </p>
      </div>
    </div>
  );
};

export default EmailVerificationInfo;
